import React from 'react'

import * as S from './grid.styled'
import type { GridProps } from './grid.types'

export const Grid = ({
  columns,
  rows,
  areas,
  align,
  justify,
  alignContent,
  gap,
  columnGap,
  rowGap,
  padding,
  paddingX,
  paddingY,
  margin,
  marginX,
  marginY,
  children,
  ...rest
}: GridProps) => {
  return (
    <S.Grid
      {...rest}
      $columns={columns}
      $rows={rows}
      $areas={areas}
      $align={align}
      $justify={justify}
      $alignContent={alignContent}
      $gap={gap}
      $columnGap={columnGap}
      $rowGap={rowGap}
      $padding={padding}
      $paddingX={paddingX}
      $paddingY={paddingY}
      $margin={margin}
      $marginX={marginX}
      $marginY={marginY}
      data-component-id="Grid"
    >
      {children}
    </S.Grid>
  )
}
